
export default [
    {
        name: 'home',
        path: '/',
        component: require('../views/Homepage.vue').default,
    },
    {
        path: '/topics',
        name: 'topics',
        component: require('../views/TorahShiurim.vue').default,
    },
    {
        path: '/masechtos',
        component: require('../views/Masechtos.vue').default,
    },
    {
        path: '/mishna',
        component: require('../views/MishnaMasechtos.vue').default,
    },
    {
        path: '/masechtos/:slug',
        component: require('../views/SingleMasechtaPage.vue').default,
        name: 'masechta',
    },
    {
        path: '/mishna/:slug',
        component: require('../views/SingleMishnaMasechtaPage.vue').default,
        name: 'mishna-masechta',
    },
    {
        path: '/magidei-shiur',
        component: require('../views/MagideiShiur.vue').default,
    },
    {
        path: '/magidei-shiur/:slug',
        name: 'magideiShiur',
        component: require('../views/magidShiur.vue').default,
    },
    {
        path: '/magidei-shiur/mishna/:slug',
        name: 'magideiShiurMishna',
        component: require('../views/magidShiurMishna.vue').default,
    },
    {
        path: '/topic/:parenttopic/:topic?',
        name: 'topic',
        component: require('../views/topics/topicsTable.vue').default,
    },
    {
        path: '/shiur/masechta-:masechta/daf-:daf',
        name: 'shiur-single',
        component: require('../views/shiur/ShasShiurSingle.vue').default,
    },
    {
        path: '/shiur/masechta-:book/perek-:perek/mishna-:mishna',
        name: 'mishna-shiur-single',
        props: true,
        component: require('../views/MishnaShiurSingle.vue').default,
    },
    {
        path: '/shiur/:id',
        name: 'torah-shiur-single',
        component: require('../views/TorahShiurSingle.vue').default,
    },
    {
        path: '/watch/:id',
        name: 'shiur-video',
        props: true,
        component: require('../views/videoPage/Index.vue').default,
    },
    {
        path: '/categories/:slug',
        name: 'category-page',
        props: true,
        component: require('../views/TorahShiurim.vue').default,
    },
    {
        name: 'donate',
        path: '/donations',
        component: require('../views/Donate.vue').default,
        meta: {
            ads: false,
        },
    },
    {
        name: 'approbations',
        path: '/haskamos',
        component: require('../views/Approbations.vue').default,
    },
    {
        name: 'resources',
        path: '/daf-resources',
        component: require('../views/Resources.vue').default,
    },
    {
        name: 'rss',
        path: '/podcasts',
        component: require('../views/Rss.vue').default,
    },
    {
        name: 'contactPage',
        path: '/contact-us',
        component: require('../views/ContactUs.vue').default,
    },
    {
        name: 'privacyPage',
        path: '/privacy-policy',
        component: require('../views/Privacy.vue').default,
    }, {
        name: 'termsAndConditions',
        path: '/terms-and-conditions',
        component: require('../views/TermsAndConditions.vue').default,
    },
    {
        name: 'aboutPage',
        path: '/about-shas-illuminated',
        component: require('../views/AboutUs.vue').default,
    },
    // {
    //   name: 'livePageNew',
    //   path: '/live',
    //   // component: require("../views/Live.vue").default
    //   component: require('../views/StaticLive.vue').default,
    // },
    {
        name: 'livePage',
        path: '/live',
        component: require('../views/LiveMaintenance.vue').default,
    },
    {
        name: 'meetingPage',
        path: '/live/:id',
        component: require('../views/live/Meeting.vue').default,
    },
    {
        name: 'zoomWebinarRedirect',
        path: '/live-stream/redirect',
        component: require('../views/live/ZoomWebinarRedirect.vue').default,
    },
    {
        name: 'webinarPage',
        path: '/live-stream/:id',
        component: require('../views/live/Webinar.vue').default,
    },
    {
        name: 'recordingPage',
        path: '/recordings/:id',
        component: require('../views/live/Recording.vue').default,
    },
    {
        name: 'profile',
        path: '/profile',
        component: require('../views/profile/UserProfile.vue').default,
    },
    {
        name: 'downloads',
        path: '/downloads',
        component: require('../views/Downloads.vue').default,
    },
    {
        path: '/speaker/:slug',
        redirect: '/:slug',
    },
    {
        path: '/:slug',
        name: 'magideiShiurTorah',
        component: require('../views/magidShiurTorah.vue').default,
    },
    // {
    //   name: 'staticPage',
    //   path: '/:slug',
    //   component: StaticPageContainerComponent,
    // },
    {
        name: '404',
        path: '/404',
        component: require('../views/errors/404.vue').default,
    },
    {
        path: '*',
        redirect: '404',
    },
    {
        name: '500',
        path: '*',
        component: require('../views/errors/500.vue').default,
    },
    {
        name: 'error',
        path: '*',
        component: require('../views/errors/error.vue').default,
    },
]